import { render, staticRenderFns } from "./DebitNotes.vue?vue&type=template&id=71eafd80&"
import script from "./DebitNotes.vue?vue&type=script&lang=js&"
export * from "./DebitNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DebitNotes.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
